import { proxy } from 'valtio';
export const jerry597_store = proxy({
    strategy: 'long',
    screener: 'long',
    pageMode: 'screener',
    pageMode2: 'paper',
});
